<section>
  <ng-container *ngFor="let categoryBadge of categoryBadges; let i = index">
    <h3>{{categoryBadge.categoryTitle | translate}}</h3>
    <div
      [class]="'container' + i"
      [opacViewportObserver]="{rootMargin: '0px 0px -10px 0px', once: true}"
      (visible)="onLazyLoad(i)">
      <app-gamification-badge
        class="badge"
        *ngFor="let badge of categoryBadge.badges; let index = index"
        [badge]="badge"
        [isFinishedAnimation]="finishedAnimations[i] >= index">
      </app-gamification-badge>
    </div>
  </ng-container>
</section>
